import { useCallback, useContext } from "react";
import Context from "../store/user-context";
import * as loginService from "../services/login-service";

export default function useUser() {
    const { authState, setAuthState } = useContext(Context);

    const login = async ({ email, password }) => {
        const response = await loginService.login({ email, password });

        if (response.status) {
            const token = response.data.accessToken;
            window.localStorage.setItem("accessToken", token);
            setAuthState({ token, user: response.data, isChecking: false });
            return Promise.resolve(true);
        }

        return Promise.reject(response.message);
    };

    const userCan = (permiso) => {
        return authState.user.permisos.includes(permiso);
    };

    const logout = async () => {
        const resp = await loginService.logout();
        if (!resp.status) return false;

        window.localStorage.removeItem("accessToken");
        setAuthState({ token: null, user: null, isChecking: false });
    };

    const getAccessToken = useCallback(
        () => authState.token,
        [authState.token]
    );
    const getUserData = useCallback(() => authState.user, [authState.user]);

    return {
        isLoggedIn: Boolean(authState.token),
        isCheckingState: authState.isChecking,
        login,
        logout,
        getAccessToken,
        getUserData,
        userCan: userCan,
    };
}
